export default __webpack_public_path__ + "static/media/big-volume-harvesting-solution.1a1774b7.png";